export default __webpack_public_path__ + "static/media/places1.79a4ea49.jpg";